import { URI_GUARD_REQUEST } from '@/config/config';

export default async ({ rootState }, { licencePlate }) => {
  try {
    const url = new URL(`${URI_GUARD_REQUEST}serpro/get-vehicle-by-license-plate/${licencePlate}`);
    const opts = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'user-token': rootState['DATA-ACCESS'].userToken,
      },
    };
  
    const response = await fetch(url, opts);
    const jsonResult = await response.json();

    if (!jsonResult.success) {
      return Promise.reject(jsonResult.message);
    }
  
    return jsonResult.details;
  } catch (error) {
    return Promise.reject(error);
  }
};
